import * as SdkConfig from '../PleasedClient/client.config';

import type { ApiResponse } from './models.pleased';
import { LazySseStream } from './LazySseStream';

export function getChatQueuePositionStream({ chatId }: { chatId: string | number }) {
  const baseUrl = SdkConfig.get('url') || '';
  const url = `${baseUrl}${baseUrl.endsWith('/') ? '' : '/'}api/v1/chat/queue-position?chatId=${chatId}`;

  return new LazySseStream<ApiResponse<{ position: number }>>({
    url,
    eventName: 'chat-queue-position-event',
    distinct: {
      kind: 'next-value-unique',
      by: (res) => res.data.position,
    },
  });
}
